import React, { Component } from 'react';
import Input from 'components/Form/Input';
import ProcessPage from 'components/ProcessPage';
import ConfirmationPage from 'containers/Auth/Register/ConfirmationPage';
import { resetPasswordRequest } from 'containers/Login/actions';
import reducer from 'containers/Login/reducer';
import saga from 'containers/Login/saga';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { compose } from 'redux';
import { Field, Form, reduxForm } from 'redux-form';
import { createStructuredSelector } from 'reselect';
import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import messages from 'utils/messages';
import validation from '../Login/validation';
import SsoPage from 'containers/Auth/SSO/SsoPage';
import { VuiButton } from '@topkamera/viso-ui';

class ResetPassword extends Component {
  state = {
    isLoading: false,
    hideLabel: false,
  };

  onSetPassword = async (payload) => {
    const { valid } = this.props;

    if (valid) {
      const { email } = payload;
      this.setState({ isSubmitting: true });
      this.props.resetPasswordRequest({ email },
        () => this.setState({ email, showConfirmationPage: true, isSubmitting: false }));
    }
  };

  render() {
    const { valid, onClose } = this.props;
    const { isSubmitting } = this.state;

    if (this.state.showConfirmationPage) {
      return (
        <ConfirmationPage
          onClose={() => this.setState({ showConfirmationPage: false })}
          title='Please verify your email'
          description='Please check your inbox'
          icon='MAIL'
          buttonLabel='Back to Login'
          footerText={<FormattedMessage {...messages.didntReceiveEmailFromUs} />}
          footerLinkUrl='mailto:info@viso.ai'
          footerLinkText={<FormattedMessage {...messages.contactUs} />}
        />
      );
    }

    return (
      <ProcessPage onClose={onClose} splitPage={true}>
        {() => (
          <div>
            <SsoPage
              title='Reset my password'
              description={`Can't log in? We'll send you a recovery link.`}
            >
              <Form
                onSubmit={this.props.handleSubmit(this.onSetPassword)}
                className="login-custom"
              >
                <div className='sso-page-form'>
                  <div className='sso-page-form__field sso-page-form__field--margin-md'>
                    <Field
                      name="email"
                      component={Input}
                      label="Email"
                    />
                  </div>
                  <div className="sso-page-form__button sso-page-form__button--margin-md vui-mt-10">
                    <VuiButton
                      disabled={!valid || isSubmitting}
                      isLoading={isSubmitting}
                      type="submit"
                      color='accent0'
                      style='filled'
                      radius='pill'
                      label='Send recovery link'
                      isBlock
                    />
                  </div>
                  <div className="sso-page-form__helper sso-page-form__helper--body">
                    <Link to="/login">
                      Return to log in
                    </Link>
                  </div>
                </div>
              </Form>
            </SsoPage>
          </div>
        )}
      </ProcessPage>
    );
  }
}


const mapStateToProps = createStructuredSelector({
  // isLoading: makeSelectLoading()
});

const withConnect = connect(
  mapStateToProps,
  { resetPasswordRequest },
);

const withReducer = injectReducer({ key: 'login', reducer });
const withSaga = injectSaga({ key: 'login', saga });

export default compose(
  reduxForm({
    form: 'RESET_FORM',
    validate: validation,
  }),
  withReducer,
  withSaga,
  withConnect,
)(ResetPassword);
